export default "__VITE_ASSET__MJUmAaje__"